import { montarSlug } from '@hooks/UtilHooks';
import { useCallback, useEffect, useState } from '@wordpress/element';
import { obterDadosEditorJs } from './auxiliares';
import { obterItemLocalStorage, subscribeListener } from './auxiliares/localStorageHelper';

export const useAnalisesParametrosEditorJs = () => {
  const [parametros, setParametros] = useState(null);
  const [valor, setValor] = useState(() => obterItemLocalStorage('artigo_em_edicao'));
  const [dadosEditor, setDadosEditor] = useState(null);

  useEffect(() => {
    const unsubscribe = subscribeListener((key, value) => {
      if (key === 'artigo_em_edicao') {
        setValor(value);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!valor) return;
    setDadosEditor(obterDadosEditorJs());
  }, [valor]);

  useEffect(() => {
    if (!dadosEditor) return;
    gerarParametrosJs();
  }, [dadosEditor]);

  const gerarParametrosJs = useCallback(() => {
    if (!dadosEditor?.html) return;

    const htmlContainer = dadosEditor?.conteudo?.blocks?.map((node, index) => ({
      html: node?.data?.text || '',
      tipo: node?.type || '',
      index,
    }));

    const slug = montarSlug(dadosEditor?.palavrasChave);

    setParametros({
      idArtigo: localStorage.getItem('id_artigo_opti'),
      idArtigoWp: dadosEditor?.id,
      titulo: dadosEditor?.titulo,
      palavraChave: dadosEditor?.palavrasChave,
      palavrasChave: [{ palavra: dadosEditor?.palavrasChave, prioritaria: true }],
      palavraChavePrioritaria: dadosEditor?.palavrasChave,
      texto: htmlContainer,
      blocos: htmlContainer,
      textoPostHtml: htmlContainer.join(''),
      url: `${window.location.origin}/${slug}`,
      slug: slug,
      tituloSeo: dadosEditor?.titulo,
      html: dadosEditor?.html,
      altImagem: dadosEditor?.alt_imagem,
      metaDescription: dadosEditor?.metadescricao,
    });
  }, [dadosEditor]);

  return { gerarParametrosJs, parametros };
};
